import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  ISectorRequest, 
  ISectorResponse, 
  ISectorDeleteRequest, 
  ISectorDeleteResponse, 
  ISectorSaveRequest, 
  ISectorSaveResponse,
  IProFormaRequest,
  IProFormaItem,
  IProFormaResponse,
  IRelacionRequest,
  IRelacionItem,
  IRelacionResponse,
  IProFormaAddRequest,
  IProFormaAddResponse,
  IProFormaDeleteRequest,
  IProFormaDeleteResponse,
  IComentarioRequest,
  IComentarioItem,
  IComentarioResponse,
  IOpcionesRequest,
  IOpcionItem,
  IOpcionesResponse,
  IComentarioSaveRequest,
  IComentarioSaveResponse,
  IComentarioUpdateRequest,
  IComentarioUpdateResponse,
  IComentarioDeleteRequest,
  IComentarioDeleteResponse,
  IFinanzaRequest,
  IFinanzaItem,
  IFinanzaResponse,
  IFinanzaSaveRequest,
  IFinanzaSaveResponse,
  IFinanzaUpdateRequest,
  IFinanzaUpdateResponse,
  IFinanzaDeleteRequest,
  IFinanzaDeleteResponse,
  IAnalisisRequest,
  IAnalisisItem,
  IAnalisisResponse
} from '../interfaces/sector.interface';

@Injectable({
  providedIn: 'root'
})
export class SectoresService {
  private apiUrl = environment.apiNewBackBaseUrl;

  constructor(private http: HttpClient) {}

  getSectores(request: ISectorRequest): Observable<ISectorResponse> {
    return this.http.post<ISectorResponse>(`${this.apiUrl}Sectores/SOspa_SectorList`, request);
  }

  createSector(request: ISectorSaveRequest): Observable<ISectorSaveResponse> {
    return this.http.post<ISectorSaveResponse>(`${this.apiUrl}Sectores/SOspa_SectorAdd`, request);
  }

  updateSector(request: ISectorSaveRequest): Observable<ISectorSaveResponse> {
    return this.http.post<ISectorSaveResponse>(`${this.apiUrl}Sectores/SOspa_SectorUpd`, request);
  }

  deleteSector(sector: string): Observable<ISectorDeleteResponse> {
    const request: ISectorDeleteRequest = {
      que: 3, tope: "", sector: sector, descripcion: "", fechaAlta: "", responsable: ""
    };
    return this.http.post<ISectorDeleteResponse>(`${this.apiUrl}Sectores/SOspa_SectorDelete`, request);
  }

  getProForma(request: IProFormaRequest): Observable<IProFormaResponse> {
    return this.http.post<IProFormaResponse>(`${this.apiUrl}Sectores/cmspr_ProformaList`, request);
  }

  getRelaciones(request: IRelacionRequest): Observable<IRelacionResponse> {
    return this.http.post<IRelacionResponse>(`${this.apiUrl}VarFinancieras/sospa_rel_finList`, request);
  }

  addProForma(request: IProFormaAddRequest): Observable<IProFormaAddResponse> {
    return this.http.post<IProFormaAddResponse>(`${this.apiUrl}Sectores/sospa_ProFormaAdd`, request);
  }

  deleteProForma(request: IProFormaDeleteRequest): Observable<IProFormaDeleteResponse> {
    return this.http.post<IProFormaDeleteResponse>(`${this.apiUrl}Sectores/sospa_ProFormaDeleteHandler`, request);
  }

  // Métodos para Comentarios
  getComentarios(request: IComentarioRequest): Observable<IComentarioResponse> {
    return this.http.post<IComentarioResponse>(`${this.apiUrl}Sectores/sospa_ComSecList`, request);
  }

  saveComentario(request: IComentarioSaveRequest): Observable<IComentarioSaveResponse> {
    return this.http.post<IComentarioSaveResponse>(`${this.apiUrl}Sectores/sospa_ComSecAdd`, request);
  }

  updateComentario(request: IComentarioUpdateRequest): Observable<IComentarioUpdateResponse> {
    return this.http.post<IComentarioUpdateResponse>(`${this.apiUrl}Sectores/sospa_ComSecUpd`, request);
  }

  deleteComentario(request: IComentarioDeleteRequest): Observable<IComentarioDeleteResponse> {
    return this.http.post<IComentarioDeleteResponse>(`${this.apiUrl}Sectores/sospa_ComSecDelete`, request);
  }

  // Métodos para Opciones del Dropdown
  getOpciones(request: IOpcionesRequest): Observable<IOpcionesResponse> {
    return this.http.post<IOpcionesResponse>(`${this.apiUrl}OpcionesSolicitud/GetOpcionesVariables`, request);
  }

  // Métodos para Finanzas
  getFinanzas(request: IFinanzaRequest): Observable<IFinanzaResponse> {
    return this.http.post<IFinanzaResponse>(`${this.apiUrl}Sectores/sospa_FinSecList`, request);
  }

  saveFinanza(request: IFinanzaSaveRequest): Observable<IFinanzaSaveResponse> {
    return this.http.post<IFinanzaSaveResponse>(`${this.apiUrl}Sectores/sospa_FinSecAdd`, request);
  }

  updateFinanza(request: IFinanzaUpdateRequest): Observable<IFinanzaUpdateResponse> {
    return this.http.post<IFinanzaUpdateResponse>(`${this.apiUrl}Sectores/sospa_FinSecUpd`, request);
  }

  deleteFinanza(request: IFinanzaDeleteRequest): Observable<IFinanzaDeleteResponse> {
    return this.http.post<IFinanzaDeleteResponse>(`${this.apiUrl}Sectores/sospa_FinSecDelete`, request);
  }

  // Métodos para Análisis
  getAnalisis(request: IAnalisisRequest): Observable<IAnalisisResponse> {
    return this.http.post<IAnalisisResponse>(`${this.apiUrl}Sectores/cmspa_analisisfinanzasList`, request);
  }

  deleteAnalisis(request: IAnalisisRequest): Observable<IAnalisisResponse> {
    return this.http.post<IAnalisisResponse>(`${this.apiUrl}Sectores/cmspa_analisisfinanzasDelete`, request);
  }

  addAnalisis(request: IAnalisisRequest): Observable<IAnalisisResponse> {
    return this.http.post<IAnalisisResponse>(`${this.apiUrl}Sectores/cmspa_analisisfinanzasAdd`, request);
  }

  updateAnalisis(request: IAnalisisRequest): Observable<IAnalisisResponse> {
    return this.http.post<IAnalisisResponse>(`${this.apiUrl}Sectores/cmspa_analisisfinanzasUpd`, request);
  }
}
